export const menu = [
  {
    "id": "1",
    "name": "首页",
    "code": "index",
    "parentName": "根节点",
    "parentCode": "0",
    "type": 1,
    "typeName": "菜单",
    "iconUrl": "menu_home",
    "jumpUrl": "/home/welcome",
    "sort": 1,
    "status": "A",
    "statusName": "正常",
    "remark": "菜单",
    "perms": "system:index",
    "createdTime": "2020-08-04 15:30:14",
    "updatedTime": "2022-01-12 19:55:38",
    "winType": "1"
  },
  {
    "id": "2",
    "name": "用户管理",
    "code": "userManagement",
    "parentName": "根节点",
    "parentCode": "0",
    "type": 1,
    "typeName": "菜单",
    "iconUrl": "menu_khgl",
    "jumpUrl": "/userManagement",
    "sort": 4,
    "status": "A",
    "statusName": "正常",
    "remark": "菜单",
    "perms": "",
    "createdTime": "2020-08-26 09:57:24",
    "updatedTime": "2022-01-12 19:56:51",
    "children": [{
      "id": "21",
      "name": "用户列表",
      "code": "userList",
      "parentName": "用户管理",
      "parentCode": "userManagement",
      "type": 1,
      "typeName": "菜单",
      "iconUrl": "0",
      "jumpUrl": "/userManagement/userList",
      "sort": 10,
      "status": "A",
      "statusName": "正常",
      "remark": "菜单",
      "perms": "userManagement:userlist:list",
      "createdTime": "2020-08-26 09:58:09",
      "updatedTime": "2022-01-12 20:10:28",
      "winType": "1"
    }],
    "winType": "1"
  },
  {
    "id": "3",
    "name": "商品管理",
    "code": "shop",
    "parentName": "根节点",
    "parentCode": "0",
    "type": 1,
    "typeName": "菜单",
    "iconUrl": "menu_khgl",
    "jumpUrl": "/shop",
    "sort": 4,
    "status": "A",
    "statusName": "正常",
    "remark": "菜单",
    "perms": "",
    "createdTime": "2020-08-26 09:57:24",
    "updatedTime": "2022-01-12 19:56:51",
    "children": [
      {
        "id": "31",
        "name": "商品列表",
        "code": "shopList",
        "parentName": "商品管理",
        "parentCode": "shop",
        "type": 1,
        "typeName": "菜单",
        "iconUrl": "0",
        "jumpUrl": "/shopManagement/shopList",
        "sort": 10,
        "status": "A",
        "statusName": "正常",
        "remark": "菜单",
        "perms": "shopManagement:shoplist:list",
        "createdTime": "2020-08-26 09:58:09",
        "updatedTime": "2022-01-12 20:10:28",
        "winType": "1"
      },
      {
        "id": "32",
        "name": "待上架商品",
        "code": "shopList",
        "parentName": "商品管理",
        "parentCode": "shop",
        "type": 1,
        "typeName": "菜单",
        "iconUrl": "0",
        "jumpUrl": "/shopManagement/pendingShop",
        "sort": 10,
        "status": "A",
        "statusName": "正常",
        "remark": "菜单",
        "perms": "shopManagement:pendingShop:list",
        "createdTime": "2020-08-26 09:58:09",
        "updatedTime": "2022-01-12 20:10:28",
        "winType": "1"
      },
      {
        "id": "33",
        "name": "商品审核",
        "code": "shopApply",
        "parentName": "商品管理",
        "parentCode": "shop",
        "type": 1,
        "typeName": "菜单",
        "iconUrl": "0",
        "jumpUrl": "/shopManagement/shopApply",
        "sort": 10,
        "status": "A",
        "statusName": "正常",
        "remark": "菜单",
        "perms": "shopManagement:shopApply:list",
        "createdTime": "2020-08-26 09:58:09",
        "updatedTime": "2022-01-12 20:10:28",
        "winType": "1"
      },
      {
        "id": "33",
        "name": "类目管理",
        "code": "categoryManage",
        "parentName": "商品管理",
        "parentCode": "shop",
        "type": 1,
        "typeName": "菜单",
        "iconUrl": "0",
        "jumpUrl": "/shopManagement/categoryManage",
        "sort": 10,
        "status": "A",
        "statusName": "正常",
        "remark": "菜单",
        "perms": "shopManagement:categoryManage:list",
        "createdTime": "2020-08-26 09:58:09",
        "updatedTime": "2022-01-12 20:10:28",
        "winType": "1"
      },
      {
        "id": "34",
        "name": "运费模板",
        "code": "transportationModel",
        "parentName": "商品管理",
        "parentCode": "shop",
        "type": 1,
        "typeName": "菜单",
        "iconUrl": "0",
        "jumpUrl": "/shopManagement/transportationModel",
        "sort": 10,
        "status": "A",
        "statusName": "正常",
        "remark": "菜单",
        "perms": "shopManagement:transportationModel:list",
        "createdTime": "2020-08-26 09:58:09",
        "updatedTime": "2022-01-12 20:10:28",
        "winType": "1"
      }
    ],
    "winType": "1"
  },
  {
    "id": "40",
    "name": "订单管理",
    "code": "orderManagement",
    "parentName": "根节点",
    "parentCode": "0",
    "type": 1,
    "typeName": "菜单",
    "iconUrl": "menu_ddgl",
    "jumpUrl": "/orderBox",
    "sort": 5,
    "status": "A",
    "statusName": "正常",
    "remark": "菜单",
    "perms": "",
    "createdTime": "2020-08-25 18:08:03",
    "updatedTime": "2022-01-12 20:04:03",
    "children": [{
      "id": "41",
      "name": "物流订单",
      "code": "logisticsOrderList",
      "parentName": "订单管理",
      "parentCode": "orderCode",
      "type": 1,
      "typeName": "菜单",
      "iconUrl": "0",
      "jumpUrl": "/orderManagement/logisticsOrderList",
      "sort": 1,
      "status": "A",
      "statusName": "正常",
      "remark": "我的订单",
      "perms": "",
      "createdTime": "2020-08-25 18:08:33",
      "updatedTime": "2022-01-12 20:11:45",
      "winType": "1"
    }, {
      "id": "42",
      "name": "售后订单",
      "code": "afterOrderList",
      "parentName": "订单管理",
      "parentCode": "orderCode",
      "type": 1,
      "typeName": "菜单",
      "iconUrl": "0",
      "jumpUrl": "/orderManagement/afterOrderList",
      "sort": 2,
      "status": "A",
      "statusName": "正常",
      "remark": "0",
      "perms": "",
      "createdTime": "2022-03-31 11:59:50",
      "updatedTime": "2022-05-23 11:49:45",
      "winType": "1"
    }],
    "winType": "1"
  },
  {
    "id": "50",
    "name": "财务管理",
    "code": "financeManagement",
    "parentName": "根节点",
    "parentCode": "0",
    "type": 1,
    "typeName": "菜单",
    "iconUrl": "menu_ddgl",
    "jumpUrl": "/financeManagement",
    "sort": 5,
    "status": "A",
    "statusName": "正常",
    "remark": "菜单",
    "perms": "",
    "createdTime": "2020-08-25 18:08:03",
    "updatedTime": "2022-01-12 20:04:03",
    "children": [{
      "id": "51",
      "name": "佣金记录表",
      "code": "commissionRecordsList",
      "parentName": "财务管理",
      "parentCode": "financeManagement",
      "type": 1,
      "typeName": "菜单",
      "iconUrl": "0",
      "jumpUrl": "/financeManagement/commissionRecordsList",
      "sort": 1,
      "status": "A",
      "statusName": "正常",
      "remark": "我的订单",
      "perms": "",
      "createdTime": "2020-08-25 18:08:33",
      "updatedTime": "2022-01-12 20:11:45",
      "winType": "1"
    }, {
      "id": "52",
      "name": "平台佣金",
      "code": "platformCommission",
      "parentName": "财务管理",
      "parentCode": "financeManagement",
      "type": 1,
      "typeName": "菜单",
      "iconUrl": "0",
      "jumpUrl": "/financeManagement/platformCommission",
      "sort": 1,
      "status": "A",
      "statusName": "正常",
      "remark": "我的订单",
      "perms": "",
      "createdTime": "2020-08-25 18:08:33",
      "updatedTime": "2022-01-12 20:11:45",
      "winType": "1"
    }, {
      "id": "53",
      "name": "平台提现",
      "code": "platformCommission",
      "parentName": "财务管理",
      "parentCode": "financeManagement",
      "type": 1,
      "typeName": "菜单",
      "iconUrl": "0",
      "jumpUrl": "/financeManagement/platformWithdrawal",
      "sort": 1,
      "status": "A",
      "statusName": "正常",
      "remark": "我的订单",
      "perms": "",
      "createdTime": "2020-08-25 18:08:33",
      "updatedTime": "2022-01-12 20:11:45",
      "winType": "1"
    }, {
      "id": "54",
      "name": "保证金",
      "code": "platformDeposit",
      "parentName": "财务管理",
      "parentCode": "financeManagement",
      "type": 1,
      "typeName": "菜单",
      "iconUrl": "0",
      "jumpUrl": "/financeManagement/platformDeposit",
      "sort": 1,
      "status": "A",
      "statusName": "正常",
      "remark": "我的订单",
      "perms": "",
      "createdTime": "2020-08-25 18:08:33",
      "updatedTime": "2022-01-12 20:11:45",
      "winType": "1"
    }, {
      "id": "55",
      "name": "平台结算金",
      "code": "platformSettlementFund",
      "parentName": "财务管理",
      "parentCode": "financeManagement",
      "type": 1,
      "typeName": "菜单",
      "iconUrl": "0",
      "jumpUrl": "/financeManagement/platformSettlementFund",
      "sort": 1,
      "status": "A",
      "statusName": "正常",
      "remark": "我的订单",
      "perms": "",
      "createdTime": "2020-08-25 18:08:33",
      "updatedTime": "2022-01-12 20:11:45",
      "winType": "1"
    }],
    "winType": "1"
  },
  {
    "id": "52",
    "name": "商城管理",
    "code": "mallManagement",
    "parentName": "根节点",
    "parentCode": "0",
    "type": 1,
    "typeName": "菜单",
    "iconUrl": "menu_ddgl",
    "jumpUrl": "/mallManagement",
    "sort": 5,
    "status": "A",
    "statusName": "正常",
    "remark": "菜单",
    "perms": "",
    "createdTime": "2020-08-25 18:08:03",
    "updatedTime": "2022-01-12 20:04:03",
    "children": [{
      "id": "58",
      "name": "商城装修",
      "code": "mallRenovation",
      "parentName": "商城管理",
      "parentCode": "mallManagement",
      "type": 1,
      "typeName": "菜单",
      "iconUrl": "0",
      "jumpUrl": "/mallManagement/mallRenovation",
      "sort": 1,
      "status": "A",
      "statusName": "正常",
      "remark": "商城装修",
      "perms": "",
      "createdTime": "2020-08-25 18:08:33",
      "updatedTime": "2022-01-12 20:11:45",
      "winType": "1"
    }, {
      "id": "59",
      "name": "首页装修",
      "code": "indexRenovation",
      "parentName": "商城管理",
      "parentCode": "mallManagement",
      "type": 1,
      "typeName": "菜单",
      "iconUrl": "0",
      "jumpUrl": "/mallManagement/indexRenovation",
      "sort": 1,
      "status": "A",
      "statusName": "正常",
      "remark": "商城管理",
      "perms": "",
      "createdTime": "2020-08-25 18:08:33",
      "updatedTime": "2022-01-12 20:11:45",
      "winType": "1"
    }],
    "winType": "1"
  },
  {
    "id": "64",
    "name": "系统管理",
    "code": "systemManagement",
    "parentName": "根节点",
    "parentCode": "0",
    "type": 1,
    "typeName": "菜单",
    "iconUrl": "menu_ddgl",
    "jumpUrl": "/systemManagement",
    "sort": 5,
    "status": "A",
    "statusName": "正常",
    "remark": "菜单",
    "perms": "",
    "createdTime": "2020-08-25 18:08:03",
    "updatedTime": "2022-01-12 20:04:03",
    "children": [{
      "id": "65",
      "name": "佣金设置",
      "code": "commissionSettings",
      "parentName": "系统管理",
      "parentCode": "systemManagement",
      "type": 1,
      "typeName": "菜单",
      "iconUrl": "0",
      "jumpUrl": "/systemManagement/commissionSettings",
      "sort": 1,
      "status": "A",
      "statusName": "正常",
      "remark": "佣金设置",
      "perms": "",
      "createdTime": "2020-08-25 18:08:33",
      "updatedTime": "2022-01-12 20:11:45",
      "winType": "1"
    }, {
      "id": "66",
      "name": "管理员设置",
      "code": "administratorSettings",
      "parentName": "系统管理",
      "parentCode": "systemManagement",
      "type": 1,
      "typeName": "菜单",
      "iconUrl": "0",
      "jumpUrl": "/systemManagement/administratorSettings",
      "sort": 1,
      "status": "A",
      "statusName": "正常",
      "remark": "管理员设置",
      "perms": "",
      "createdTime": "2020-08-25 18:08:33",
      "updatedTime": "2022-01-12 20:11:45",
      "winType": "1"
    }, {
      "id": "67",
      "name": "角色设置",
      "code": "rolesSettings",
      "parentName": "系统管理",
      "parentCode": "systemManagement",
      "type": 1,
      "typeName": "菜单",
      "iconUrl": "0",
      "jumpUrl": "/systemManagement/rolesSettings",
      "sort": 1,
      "status": "A",
      "statusName": "正常",
      "remark": "角色设置",
      "perms": "",
      "createdTime": "2020-08-25 18:08:33",
      "updatedTime": "2022-01-12 20:11:45",
      "winType": "1"
    }, {
      "id": "68",
      "name": "登录记录",
      "code": "loginRecord",
      "parentName": "商城管理",
      "parentCode": "systemManagement",
      "type": 1,
      "typeName": "菜单",
      "iconUrl": "0",
      "jumpUrl": "/systemManagement/loginRecord",
      "sort": 1,
      "status": "A",
      "statusName": "正常",
      "remark": "登录记录",
      "perms": "",
      "createdTime": "2020-08-25 18:08:33",
      "updatedTime": "2022-01-12 20:11:45",
      "winType": "1"
    }],
    "winType": "1"
  }
];